/**
 * Aritmética de noites, e SÓ ela.
 *
 * Mora no contrato (`src/index.ts` reexporta `hotel_rooms_builder`, que importa
 * daqui), que não carrega React nem pacote de UI. A pluralização ("3 noites")
 * vive no kit, em `hotel_planner/ui/hotel_date_calendar.tsx`, do lado de quem
 * escolhe as datas.
 */
const DAY_MS = 86_400_000;

/**
 * Noites entre duas datas `YYYY-MM-DD` — a casa única da conta.
 *
 * Havia TRÊS cópias: o calendário do planner, a faixa de busca e o builder do
 * `hotel_rooms`. Ficou a UTC — `Date.parse` de data-só é UTC por especificação,
 * então a subtração é de epoch puro e a divisão já cai exata. Duas das três já
 * eram essa, diferindo só na grafia; a do CALENDÁRIO construía `Date` local
 * (`fromIso`, que continua lá pra grade do rdp) e era a única em que o
 * `Math.round` era load-bearing — meia-noite local de dois dias não distam 24h
 * exatas na virada do horário de verão. Aqui o `round` é cinto, não o que segura
 * a conta.
 *
 * Não valida: quem passa data torta é quem tem o contexto pra decidir o que
 * fazer com ela (ver `nightsFromStay`).
 */
export function nightsBetween(checkin: string, checkout: string): number {
  return Math.round((Date.parse(checkout) - Date.parse(checkin)) / DAY_MS);
}

/**
 * A mesma conta para uma estadia FROUXA — pontas opcionais, resultado só se
 * fizer sentido. É o que o builder precisa: estadia incompleta ou invertida não
 * vira `0 noites` nem `-2 noites` no bloco, vira ausência.
 */
export function nightsFromStay(
  checkin: string | undefined,
  checkout: string | undefined,
): number | undefined {
  if (!checkin || !checkout) return undefined;
  const nights = nightsBetween(checkin, checkout);
  return nights > 0 ? nights : undefined;
}
